import { Instance, SnapshotOut, types } from "mobx-state-tree"

import { withEnvironment } from "../extensions/with-environment";
import {
  IMessage,
  withRootStore,
} from "../../models";
import {
  TGeneralApiResponse,
  CommonCodeApi
} from "../../services";
import { withSetPropAction } from "../extensions/withSetPropAction";
import { CommonCode, ICommonCode } from '../common-code/CommonCode';

/**
 * # CommonCodeStore
 * 
 * CommonCodeStore을 설명하세요.
 */

export const CommonCodeStore = types
  .model("CommonCodeStore")
  // --------------------------------------------------------------------------
  .props({
    cdssCodes: types.optional(types.array(CommonCode), []),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .actions(withSetPropAction)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    setCdssCodes: (cdssCodes: ICommonCode[]) => {
      self.cdssCodes.replace(cdssCodes);
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청 
  .actions((self) => ({

    /** CdssCodes 공통 코드 리스트 조회 */
    getCdssCodes: async () => {
      self.setCdssCodes([] as ICommonCode[]);
      self.rootStore.messageStore.setMessage({} as IMessage);

      try {
        const commonCodeApi: CommonCodeApi = new CommonCodeApi(self.environment.api);
        const result: TGeneralApiResponse = await commonCodeApi.getCdssCodes();
        if (self.rootStore.responseStore.getResponseResult(result)) {
          if (self.rootStore.responseStore.responseInfo.resultCode == 'S') {
            const cdssCodes = JSON.parse(JSON.stringify(result)).responseInfo.data;
            self.setCdssCodes(cdssCodes);

          } else {
            if (self.rootStore.responseStore.responseInfo.message) {
              self.rootStore.messageStore.setMessage({
                content: self.rootStore.responseStore.responseInfo.message,
                isError: true,
              } as IMessage);
            }
          }
        }
      } catch (e) {
        self.rootStore.messageStore.setMessage({
          content: '서버 접속이 원활하지 않습니다. 지속적으로 발생할 경우 관리자에게 문의해주세요.',
          isError: true,
        } as IMessage);
      }
    },
  }))

// --------------------------------------------------------------------------
type TCommonCodeStore = Instance<typeof CommonCodeStore>;
type TCommonCodeStoreSnapshot = SnapshotOut<typeof CommonCodeStore>

export interface ICommonCodeStore extends TCommonCodeStore { }
export type TCommonCodeStoreKeys = keyof TCommonCodeStoreSnapshot & string;
export interface ICommonCodeStoreSnapshot extends TCommonCodeStoreSnapshot { }
export const createCommonCodeStore = () =>
  types.optional(CommonCodeStore, {} as TCommonCodeStore);
